var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.4,
    cy: 31.315,
    rx: 30.4,
    ry: 30.411,
    fill: "white",
    stroke: "#28947F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2672 21.0252C44.8123 20.5645 44.0618 20.5517 43.5908 20.9967C43.5809 21.006 43.5712 21.0155 43.5616 21.0252L24.2446 39.9198L17.9692 33.7817C17.4982 33.3367 16.7477 33.3495 16.2928 33.8102C15.849 34.2596 15.849 34.9721 16.2928 35.4215L23.4064 42.3795C23.8694 42.8323 24.6199 42.8323 25.0828 42.3795L45.238 22.665C45.709 22.22 45.7221 21.4859 45.2672 21.0252Z",
    fill: "#28947F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/CheckedIcon.1b74c0386509d02eaf0587894e18853a.svg";
export { ForwardRef as ReactComponent };